<div
  class="grid transition-[grid-template-columns] duration-300 ease-in-out overflow-hidden"
  [style.gridTemplateColumns]="collapsed() ? '85px minmax(0, 1fr)' : '300px minmax(0, 1fr)'"
  [style.height]="'calc(100vh - 3.5rem)'"
>
  <div
    class="bg-gray-100 border-r border-gray-300 h-full overflow-hidden relative transition-all duration-300"
    [ngClass]="{ 'px-2': !collapsed(), 'px-1': collapsed() }"
  >
    <div class="flex justify-end">
      <button
        (click)="toggleSidebar()"
        class="pt-2 self-start text-gray-500 hover:text-gray-700 transition-colors"
        [attr.aria-label]="collapsed() ? 'Expand Client List' : 'Collapse Client List'"
      >
        <i class="pi" [ngClass]="collapsed() ? 'pi-angle-right' : 'pi-angle-left'"></i>
      </button>
    </div>
    <ng-content select="[column1]"></ng-content>
  </div>

  <div class="flex flex-col h-full min-h-0 min-w-0 bg-white relative overflow-hidden">
    <bai-client-metadata></bai-client-metadata>
    <ng-content select="[column2]"></ng-content>
  </div>
</div>
